import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Accelerator() {
  const rows = [{
    sit: 'Tenés los PDFs pero no sabés por dónde empezar',
    sin: 'Parálisis. Los guardás sin usar.',
    con: 'Día 1 al 30 exactamente definidos.'
  }, {
    sit: 'Querés subir precios pero lo postergás',
    sin: 'Sigue igual el mes que viene',
    con: 'Día 5: precio calculado y publicado'
  }, {
    sit: 'No sabés cómo conectar los tomos entre sí',
    sin: 'Cada PDF parece un mundo aparte',
    con: 'El mapa muestra cómo todo encaja'
  }, {
    sit: 'Querés medir si funcionó',
    sin: 'No tenés con qué comparar',
    con: 'Auditoría Día 0 vs Día 30 con números reales'
  }];
  return <section className="py-16 px-4 bg-dark-card/30" data-id="element-28">
      <div className="max-w-4xl mx-auto" data-id="element-29">
        <div className="text-center mb-12" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-31">
            🚀 ¿QUÉ AGREGA EL ACELERADOR "RUTA CRÍTICA 30 DÍAS"?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-32">
            El Acelerador es el mapa que convierte 480 páginas en 30 acciones
            concretas. Un día, una acción. Sin abrumarse.
          </p>
        </div>

        <div className="space-y-6" data-id="element-33">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl overflow-hidden" data-id="element-34">
              <div className="p-6 border-b border-dark-border" data-id="element-35">
                <h3 className="text-lg font-bold text-white" data-id="element-36">{row.sit}</h3>
              </div>
              <div className="grid md:grid-cols-2" data-id="element-37">
                <div className="p-6 bg-red-500/5 border-r border-dark-border" data-id="element-38">
                  <div className="flex items-center space-x-2 mb-3" data-id="element-39">
                    <X className="w-5 h-5 text-red-400" data-id="element-40" />
                    <span className="font-bold text-red-400" data-id="element-41">
                      Sin Acelerador
                    </span>
                  </div>
                  <p className="text-gray-400" data-id="element-42">{row.sin}</p>
                </div>
                <div className="p-6 bg-brand/5" data-id="element-43">
                  <div className="flex items-center space-x-2 mb-3" data-id="element-44">
                    <Check className="w-5 h-5 text-brand" data-id="element-45" />
                    <span className="font-bold text-brand" data-id="element-46">Con Acelerador</span>
                  </div>
                  <p className="text-white font-medium" data-id="element-47">{row.con}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}